export var EComponentType;
(function (EComponentType) {
    EComponentType["Ionic"] = "ionic";
    EComponentType["Web"] = "web";
})(EComponentType || (EComponentType = {}));
//# sourceMappingURL=types.js.map